import { styled, Box } from '@mui/material';

const StyledBoldSpan = styled('span')(() => ({
  fontWeight: 600,
  display: 'inline-block',
  paddingRight: '5px',
  fontSize: '16px',
}));

const StyledSpan = styled('span')(() => ({
  display: 'inline-block',
  fontSize: '16px',
}));

const StyledBox = styled(Box)(() => ({
  position: 'relative',
}));

const StyledIconWrapper = styled('div')(() => ({
  position: 'absolute',
  left: '-30px',
  top: '50%',
  transform: 'translateY(-60%)',
  cursor: 'pointer',
}));

export { StyledSpan, StyledBox, StyledIconWrapper };
export default StyledBoldSpan;
